
<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> 業種管理
              <div class="card-header-actions">
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <CButton size="sm" color="info" @click="showRecordModal({}, 0, 'Create')">新規作成</CButton>
                </a>
              </div>
            </CCardHeader>
            <CCardBody>


              <CDataTable
                :hover="true"
                :striped="true"
                :items="items"
                :fields="fields"
                itemsPerPage="30"
                pagination
              >
                <template #name="{item}">
                  <td>
                    <CLink :href="'/industries/' + item.id" > {{ item.name }}</CLink>
                  </td>
                </template>
                <template #created_at="{item}">
                  <td> {{formatDate(item.created_at)}}</td>
                </template>
                <template #updated_at="{item}">
                  <td> {{formatDate(item.created_at)}}</td>
                </template>
                <template #show_details="{item, index}">
                  <td class="py-2">
                    <CButton class="mr-2" color="dark" variant="outline" square size="sm" @click="showRecordModal(item, index)">編集</CButton>
                    <CButton color="danger" variant="outline" square size="sm" @click="showDeleteModal(item, index)">削除</CButton>
                  </td>
                </template>

                <template #under-table>

                  <CCol sm="12" class="text-center">
                    <paginate
                      :page-count="meta.total_pages"
                      :prev-text="'前へ'"
                      :next-text="'次へ'"
                      :click-handler="paging"
                      :container-class="'pagination'">
                    </paginate>
                  </CCol>
                </template>


              </CDataTable>
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>

    <CModal
      :title="modalModeTitle()"
      :color="modalModeCss()"
      :show.sync="recordModal"
    >
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">業種名</label>
           <CInput
             placeholder="例) 水産"
             v-model="record.name"
             :class="{ 'hasError': $v.record.name.$error }"
             required
           />
           <small v-if="$v.record.name.$error" class="errorLabel">業種名を入れてください</small>
         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">業種に関する説明</label>
           <CTextarea
             placeholder="例)漁師等"
             rows="5"
             :class="{ 'hasError': $v.record.description.$error }"
             v-model="record.description"
           />
           <small v-if="$v.record.description.$error" class="errorLabel">説明を入れてください</small>
         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label pt-3">試験での実施言語</label>
           <CInput placeholder="実施言語" v-model="record.language" :class="{ 'hasError': $v.record.name.$error }"/>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">実施方法</label>
           <CInput placeholder="実施方法" v-model="record.method"/>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">実施方式</label>
           <CInput placeholder="実施方式" v-model="record.way"/>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">試験区分</label>
           <CTextarea
             placeholder="例)試験の範囲を入力してください"
             rows="5"
             v-model="record.section"
           />
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">試験結果の通知方法</label>
           <CInput placeholder="例) ホームページにて結果を通知します" v-model="record.notify"/>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">試験結果の合格基準</label>
           <CInput placeholder="試験結果の通知方法" v-model="record.border"/>
         </CCol>
       </CRow>

       <template #footer>
         <CButton size="sm" @click="hideRecordModal()">キャンセル</CButton>
         <CButton size="sm" color="info" @click="updateItem(mode, itemIndex)">登録</CButton>
       </template>
    </CModal>
    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deleteModal"
    >
      <div class="text-center">
        <p>この業種を削除しますか？？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deleteItem()">削除</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
//TODO: ぱんくず

import axios from 'axios';
import moment from 'moment';
import { required } from "vuelidate/lib/validators";
import Paginate from 'vuejs-paginate'
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {
    Paginate
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'id', label: ""},
        { key: 'name', label: "業種名"},
        { key: 'description', label: "業種に関する説明"},
        { key: 'created_at', label: "作成日"},
        { key: 'updated_at', label: "最終更新日"},
        { key: 'show_details',  label: '',  _style: 'width:15%', sorter: false, filter: false}],
      recordModal: false,
      deleteModal: false,
      mode: "",
      username: '',
      password: '',
      itemIndex: 0,
      meta: {},
      record: {
        name: "",
        description: ""
      },
    }
  },
  validations: {
    record: {
      name: {required},
      description: {required}
    }
  },
  methods: {
    login () {
      this.$cognito.login(this.username, this.password)
        .then(result => {
          console.log(result)
          this.$router.replace('/home')
        })
        .then(err => {
          this.error = err
        })
    },
    paging: function(n) {
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/industries?page=" + n, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            console.log(response.data.industries)
            this.items = response.data.industries
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    formatDate: function(d) {
      return moment(d).format("YYYY/MM/DD HH:mm")
    },
    validator (val) {
      return val ? val.length >= 1 : false
    },
    modalModeCss: function() {
      return (this.mode == "Create")? "info" : "dark"
    },
    modalModeTitle: function() {
      return (this.mode == "Create")? "新規業種追加" : "編集"
    },
    showRecordModal: function(i, index, mode="Edit") {
      this.recordModal = true
      this.record = i

      this.mode = mode
      this.itemIndex = index
    },
    showDeleteModal: function(i, index) {
      this.deleteModal = true
      this.record = i
      this.itemIndex = index
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    hideDeleteModal: function() {
      this.deleteModal = false
    },
    updateItem: function(mode="Create", index=0) {
      this.$v.record.$touch();
      if(this.$v.record.$error) return

      if(mode == "Create") {
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/industries", {"industry": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.recordModal = false
            this.items.push(response.data)
          }).catch(error => {
            this.errorNotify(error.response)
          })
      } else {
        axios
          .patch(process.env.VUE_APP_API_ENDPOINT + "/industries/" + this.record.id, {"industry": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(() => {
            this.recordModal = false
            this.items[index] = this.record
          }).catch(error => {
            this.errorNotify(error.response)
          })
      }
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/industries/" + this.record.id)
        .then(() => {
          this.items.splice(this.itemIndex, 1)
          this.hideDeleteModal()
        }).catch(error => {
          this.errorNotify(error.response)
        })
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/industries", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          console.log(response.data.industries)
          this.items = response.data.industries
          this.meta = response.data.meta
      }).catch(error => {
          this.errorNotify(error.response)
      })
  },
    computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>
